// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"106":"music","555":"insta","596":"404"}[chunkId] + "." + {"106":"7e8e01ab","555":"67d0faa1","596":"0f5120de"}[chunkId] + ".css";
};